import { onReady } from '@/core/utils/dom';
import { jsClassSelectorToHtml } from '@/core/utils/string';
import { SELECTORS } from './navigation.config';

const activeClass = jsClassSelectorToHtml(SELECTORS.active);
const activeMenu = SELECTORS.listItem + SELECTORS.active;

function toggleNavMenu(element: Element): void {
	const parent = element.closest(SELECTORS.listItem);

	if (!parent) return;
	const menu = parent.querySelector(SELECTORS.menu);

	// If it's active, make it inactive
	if (parent.classList.contains(activeClass)) {
		parent.classList.remove(activeClass);
		element.setAttribute('aria-expanded', 'false');
		menu?.setAttribute('hidden', 'true');

		return;
	}

	// If it's inactive...

	// Deactivate siblings and children
	parent.parentElement?.querySelectorAll(SELECTORS.listItem).forEach((item) => {
		if (item === parent) return;

		item.classList.remove(activeClass);
		item
			.querySelector(SELECTORS.button)
			?.setAttribute('aria-expanded', 'false');
		item.querySelector(SELECTORS.menu)?.setAttribute('hidden', 'true');
	});

	// Make it active
	parent.classList.add(activeClass);
	element.setAttribute('aria-expanded', 'true');
	menu?.removeAttribute('hidden');
}

function setNavActive(element: Element, nav: Element): void {
	nav.classList.add(activeClass);
	element.classList.add(activeClass);
	document.body.classList.add(activeClass);
	element.setAttribute('aria-expanded', 'true');
	nav.removeAttribute('hidden');
}

function setNavInactive(element: Element, nav: Element): void {
	nav.classList.remove(activeClass);
	element.classList.remove(activeClass);
	document.body.classList.remove(activeClass);
	element.setAttribute('aria-expanded', 'false');
	nav.setAttribute('hidden', 'true');
}

function toggleNav(element: Element, nav: Element): void {
	const isActive = element.classList.contains(activeClass);

	if (isActive) {
		setNavInactive(element, nav);
		return;
	}

	setNavActive(element, nav);
}

function closeMenuOnBackgroundClick(event: Event, element: Element): void {
	const target = event.target instanceof Node ? event.target : null;

	if (!target) return;
	if (element.contains(target)) return;

	document.querySelectorAll(activeMenu).forEach((menu) => {
		menu.classList.remove(activeClass);

		menu
			.querySelector(SELECTORS.button)
			?.setAttribute('aria-expanded', 'false');

		menu.querySelector(SELECTORS.menu)?.setAttribute('hidden', 'true');
	});
}

function attachListeners() {
	document.querySelectorAll(SELECTORS.button).forEach((element) => {
		element.addEventListener('click', () => toggleNavMenu(element));
	});

	const mainNav = document.querySelector(SELECTORS.mainNav);

	if (mainNav) {
		document.addEventListener('click', (event) =>
			closeMenuOnBackgroundClick(event, mainNav),
		);
	}

	const toggle = document.querySelector(SELECTORS.toggle);

	if (!toggle) return;

	const headerNav = document.querySelector(SELECTORS.headerNav);

	if (!headerNav) return;

	toggle.addEventListener('click', () => toggleNav(toggle, headerNav));
}

onReady(attachListeners);
